import { FlexBox } from '@ardoq/layout';
import { ReactNode } from 'react';
import { AiDisclaimer } from './AiDisclaimer';
import {
  AiFeedback,
  AiFeedbackNegativeCategory,
  AiFeedbackProps,
} from './AiFeedback';

export type AiFeedbackWithDisclaimerProps<
  T extends string = AiFeedbackNegativeCategory,
> = AiFeedbackProps<T> & {
  disclaimer?: string;
};

export const AiFeedbackWithDisclaimer = <T extends string>({
  disclaimer,
  ...feedbackProps
}: AiFeedbackWithDisclaimerProps<T>): ReactNode => {
  if (!feedbackProps.isVisible) return null;
  return (
    <FlexBox
      align="center"
      justify="space-between"
      padding="large"
      paddingBottom="none"
    >
      <AiDisclaimer i18nLocale={feedbackProps.i18nLocale} text={disclaimer} />
      <AiFeedback {...feedbackProps} />
    </FlexBox>
  );
};
